import { generatePath, useNavigate } from 'react-router-dom';
import { ButtonPseudo, IconInfo } from '@ui/src';
import { useAppDispatch } from '@store';
import ROUTES from '../../../routes';
import { onRoleChange } from '../../../hoc/user-roles/store/slices/roles';
import { ColumnRowRolesTypes } from './types';

import cn from './styles.module.css';

const ColumnRowRoles = ({
  role,
  isSelectedRow,
}: ColumnRowRolesTypes): React.JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <div
      className={`${cn.columnRow} ${isSelectedRow ? cn.columnRowActive : ''}`}
    >
      <button
        onClick={() => {
          dispatch(onRoleChange(role.id));
        }}
        className={`${cn.columnRowLink} ${
          isSelectedRow ? cn.columnRowLinkActive : ''
        }`}
        aria-label="select row"
        type="button"
      />
      <ButtonPseudo
        icon={<IconInfo />}
        className={`button-white ${cn.columnRowButton}`}
        onClick={() => {
          dispatch(onRoleChange(role.id));
          navigate(generatePath(ROUTES.ROLE_EDIT, { roleId: role.id }));
        }}
      />
      {role.active ? (
        <div className={cn.columnRowWrapper}>
          <div className={cn.columnRowTitle}>{role.name}</div>
          <div className={cn.columnRowCount}>{role.usersCount} users</div>
        </div>
      ) : (
        <div className={cn.columnRowWrapperArchived}>
          <div className={cn.columnRowTitleArchived}>{role.name}</div>
          <div className={cn.columnRowTextArchived}>Archived</div>
        </div>
      )}
    </div>
  );
};

export default ColumnRowRoles;
